import { createContext, useState, useEffect } from "react";
import axios from "../utils/api";

export const AuthContext = createContext();

export default function AuthProvider({ children }) {
    const [user, setUser] = useState(null);

    useEffect(() => {
        axios.get("/auth/me")
            .then(res => setUser(res.data))
            .catch(() => {});
    }, []);

    return (
        <AuthContext.Provider value={{ user, setUser }}>
            {children}
        </AuthContext.Provider>
    );
}